import React from 'react'
import {
    Form,
    FormFeedback,
    FormGroup,
    Input,
    Label,
    ModalBody,
    Row
} from 'reactstrap'

import Select from 'react-select';
import '../../components/precodedTexts/StylePrecodedText.css'

export const FormPrecodedText = (props) => {

    const {
        loading,
        id_type_precoded_text,
        text,
        typePrecodedTexts,
        handleInputChange,
        validaciones,
        methodAction
    } = props;

    const {
        text: validacionText
    } = validaciones;

    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '35px',
            borderRadius: '12px',
            borderColor: state.isFocused
                ? '#46AFE5'
                : '#dbe4f0',
            boxShadow: state.isFocused
                ? '0 0 0 3px rgba(70,175,229,.15)'
                : 'none',
                fontSize: '12px',
            transition: 'all .2s ease',
            '&:hover': {
                borderColor: '#46AFE5'
            }
            
        }),

        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? '#46AFE5'
                : state.isFocused
                    ? '#eef7fd'
                    : '#fff',
            color: state.isSelected ? '#fff' : '#334155',
            cursor: 'pointer'
        }),

        placeholder: (provided) => ({
            ...provided,
            color: '#94a3b8'
        }),

        menuPortal: (base) => ({
            ...base,
            zIndex: 999999
            }),

            menu: (provided) => ({
                ...provided,
                zIndex: 999999,
                position: 'absolute'
        }),

    };

    

    return (
        <Form onSubmit={methodAction}>
            <div className='form-section'>

                <div className="precodedHeader">
                    <div className="precodedIcon">
                        <i className="fa fa-file-text-o"></i>
                    </div>

                    <div>
                        <h5 className="precodedTitle">
                            Texto precodificado
                        </h5>

                        <p className="precodedSubtitle">
                            Configura el tipo y contenido del texto
                        </p>
                    </div>
                </div>

                <Row>

                    <FormGroup className='mb-4 col-12'>

                        <Label className="precodedLabel">
                            Tipo de texto
                        </Label>

                        <Select
                            classNamePrefix="select"
                            name="id_type_precoded_text"
                            options={typePrecodedTexts.map((u) => ({
                                value: u.id_type_precoded_text,
                                label: u.name
                            }))}

                            value={
                                typePrecodedTexts
                                    .map((u) => ({
                                        value: u.id_type_precoded_text,
                                        label: u.name
                                    }))
                                    .find((opt) =>
                                        opt.value === id_type_precoded_text
                                    ) || null
                            }

                            placeholder="Selecciona una opción"
                            isClearable={false}

                            onChange={(e) =>
                                handleInputChange({
                                    target: {
                                        name: "id_type_precoded_text",
                                        value: e ? e.value : ""
                                    }
                                })
                            }

                            styles={customSelectStyles}

                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />

                        <FormFeedback>
                            Debes seleccionar una opción
                        </FormFeedback>

                    </FormGroup>

                    <FormGroup className="mb-2 col-12">

                        <Label className="precodedLabel">
                            Texto
                        </Label>

                        <Input
                            type="textarea"
                            rows="2"
                            name="text"
                            value={text}
                            onChange={handleInputChange}
                            required={true}
                            autoComplete="off"
                            invalid={validacionText}
                            placeholder="Escribe el texto precodificado..."
                            className="precodedTextarea"
                        />

                        <FormFeedback>
                            El texto debe tener 3 o más caracteres
                        </FormFeedback>

                    </FormGroup>

                </Row>

            </div>
        </Form>
    )
}